import Tooltip from './../../node_modules/bootstrap/js/dist/tooltip.js';

import ModulesLoader from './modulesLoader';
import Toggle from './modules/toggle';
import Close from './modules/close';
import CopyToClipboard from './modules/copyToClipboard.js';
import Daterange from './modules/daterange.js';

const modules = {
  'toggle': Toggle,
  'close': Close,
  'copy-to-clipbord': CopyToClipboard,
  'daterange': Daterange
};

window.addEventListener('load', () => {
  const modulesLoader = new ModulesLoader(modules);
  modulesLoader.init();

  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))

  tooltipTriggerList.map(tooltipTriggerEl => {
    return new Tooltip(tooltipTriggerEl)
  });
});
